import { FC } from 'react'
import styled from 'styled-components'
import useIsMobile from '@app.modules/hooks/useIsMobile'
import { mobileBreakPoint } from 'app.styled/media'
import ScreenChannelSearchDesktop from './ScreenChannelSearch.desktop'
import ScreenChannelSearchMobile from './ScreenChannelSearch.mobile'

const ScreenChannelSearch: FC = () => {
  const isMobile = useIsMobile()

  return (
    <StyledWrapper>
      <div className="mobile">{isMobile && <ScreenChannelSearchMobile />}</div>
      <div className="desktop">
        {!isMobile && <ScreenChannelSearchDesktop />}
      </div>
    </StyledWrapper>
  )
}

export default ScreenChannelSearch

const StyledWrapper = styled.div`
  background-color: #f5f6f8;
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  ${mobileBreakPoint} {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
`
